import { render, staticRenderFns } from "./Brieven.vue?vue&type=template&id=470a512c&scoped=true"
import script from "./Brieven.vue?vue&type=script&lang=js"
export * from "./Brieven.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a512c",
  null
  
)

export default component.exports